import { render, staticRenderFns } from "./sysNotice.vue?vue&type=template&id=3ae88755&scoped=true"
import script from "./sysNotice.vue?vue&type=script&lang=js"
export * from "./sysNotice.vue?vue&type=script&lang=js"
import style0 from "./sysNotice.vue?vue&type=style&index=0&id=3ae88755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae88755",
  null
  
)

export default component.exports